import { createCoreMethod } from '../../utils/createCoreMethod';

export const getCoreVersion = createCoreMethod('getCoreVersion', async () => {
  return BUILD_VERSION;
});
